import Form from 'components/Form';
import PhoneField from 'components/PhoneField';
import Button from 'components/Button';
import useControllerNumberPage from './_presenters/useControllerNumberPage/useControllerNumberPage';
import Icon from '../../../components/Icon';
import { Link } from 'react-router-dom';
import React from 'react';

const NumberPage = () => {
  const { formMethods, handleOnSubmit } = useControllerNumberPage();

  return (
    <div className="d-flex flex-column align-items-center mt-4">
      <div className={'w-100'}>
        <Link className="back-button" to={`/`}>
          <Icon icon="chevron-left" width={64} height={64} />
          Voltar
        </Link>
      </div>
      <Form onSubmit={handleOnSubmit} {...formMethods}>
        <div className="d-flex flex-column align-items-center">
          <div className="mb-4 text-margin">
            <p className="font-size-3 font-color fw-medium">
              Para qual número você quer fazer recarga?
            </p>
          </div>
          <PhoneField
            name="phone"
            placeholder="(00) 00000-0000"
            className="input-number"
          />
          <div className="mt-5">
            <Button type="submit" className="button-continue">
              Continuar
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default NumberPage;
